import NumberFormat from '../const/NumberFormat';

const numberFormat = {
  methods: {
    roundNumber(value, digits = NumberFormat.NUMBER_FORMAT_DIGITS) {
      return Number(this.trimNumber(value, digits));
    },
    trimNumber(value, digits = NumberFormat.NUMBER_FORMAT_DIGITS) {
      return Number(value).toFixed(digits);
    },
  },
};
export default numberFormat;
